<template>
    <div class="container bg-white border rounded-3 p-4">

        <div class="card mb-4 shadow-sm">
            <div class="card-header d-flex justify-content-between align-items-center bg-light">
                <strong class="text-danger">🕒 Modified: {{ $formatDateTime(order.updated_at) }}</strong>

            </div>

            <div class="card-body">
                <div class="doctor-order-detail">

                    <h5 class="section-title">1. Client Information</h5>
                    <p><strong>Client Name:</strong> {{ order.student?.user?.name }} <strong class="ms-3">Date:</strong>
                        {{ $formatDate(order.date) }}</p>
                    <hr />

                    <h5 class="section-title">2. Reason for Visit or Complaint</h5>
                    <ul>
                        <li v-for="(reason, index) in JSON.parse(order.reason || '[]')" :key="index">
                            {{ reason }}
                        </li>
                    </ul>
                    <p><strong>Findings:</strong> {{ order.findings }}</p>
                    <hr />

                    <h5 class="section-title">4. Plan / Treatment Recommendations</h5>
                    <ul>
                        <li v-for="(p, i) in order.plans" :key="i">{{ p.plan }}</li>
                    </ul>

                    <h5 class="section-title mt-4">Medications including Indications for Medications</h5>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Medication</th>
                                <th>Start Date</th>
                                <!-- <th>End Date</th> -->
                                <th>Indications</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="text-align: left !important;" v-for="(m, i) in order.medications" :key="i">
                                <td>{{ m.name }}</td>
                                <td>{{ $formatDate(m.start_date) }}</td>
                                <!-- <td>{{ $formatDate(m.end_date) }}</td> -->
                                <td>{{ m.indication }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="section-title mt-4">Standing Orders for Clients in Intensive Outpatient</h5>
                    <ul class="standing-orders">
                        <li v-for="(medication, i) in allMedications" :key="i">
                            <strong>{{ medication.name }}</strong> {{ medication.symptom_treated }}, {{
                                medication.frequency_dosage }}
                        </li>
                    </ul>

                    <div class="yes-no-section mt-4">
                        <p>
                            May Client continue to take medication from standing orders?
                            <strong>{{ order.allow_standing_orders ? 'Yes' : 'No' }}</strong>
                        </p>
                        <p>
                            Does client have permission to take medications upon discharge?
                            <strong>{{ order.discharge_meds_permission ? 'Yes' : 'No' }}</strong>
                        </p>
                        <p>
                            May Client continue to all previous orders?
                            <strong>{{ order.continue_previous_orders ? 'Yes' : 'No' }}</strong>
                        </p>
                    </div>
                </div>

                <!-- <div class="d-flex justify-content-end mt-4">
                    <button class="btn btn-sm btn-outline-primary" @click="$router.push('/dashboard/clients')">
                        👤 View Clients
                    </button>
                </div> -->
            </div>
        </div>

        <div>
            <div v-if="signatureData">
                <label class="form-label">Signature:</label>
                <h1 class="signature-font-lg">
                    {{ signatureData }}
                </h1>
            </div>

            <div class="mb-3">
                <label class="form-label">Signed Date:</label>
                <input type="date" v-model="signedAt" class="form-control" />
            </div>

            <button class="btn btn-sm btn-success" @click="saveSignatureDate">
                💾 Save Signature
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            signatureData: {},
            signedAt: '',
            loading: true,
            errorMessage: '',
            order: {},
        };
    },
    mounted() {
        this.fetchSignature();
        this.fetchOrder();
    },
    methods: {
        async fetchOrder() {
            const res = await this.$api.get(`/doctor-orders/${this.id}`);
            this.order = res.data;

        },
        async fetchSignature() {
            try {
                const res = await this.$api.get('/practitioners/signature');
                this.signatureData = res.data;
                this.signedAt = this.signatureData.signed_at || '';
                this.loading = false;
            } catch (err) {
                this.errorMessage = err.response?.data?.message || 'Failed to load signature.';
                this.loading = false;
            }
        },
        async saveSignatureDate() {
            // if (!this.signatureData.doctor_order_id) {
            //     alert("Doctor Order ID not found.");
            //     return;
            // }

            try {
                await this.$api.post(`/doctor-orders/savePractitionerSignature`, {
                    signature: this.signatureData.signature,
                    // practitioner_id: this.signatureData.practitioner_id,
                    signed_at: this.signedAt,
                    id: this.id,
                });
                // this.$router.push({ name: 'DoctorOrders' });
                this.$router.back();

            } catch (err) {
                alert("Failed to save: " + (err.response?.data?.message || ''));
            }
        }
    }
};
</script>
